import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export interface InactivityWarningModalProps {
    open: boolean;               // Controla visibilidade
    remainingSeconds: number;    // Segundos restantes
    onContinue: () => void;     // Ação ao clicar "Continuar"
}

export const InactivityWarningModal: React.FC<InactivityWarningModalProps> = ({
    open,
    remainingSeconds,
    onContinue
}) => {
    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            aria-labelledby="inactivity-warning-title"
            aria-describedby="inactivity-warning-description"
            sx={{ zIndex: 10000001 }}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                elevation: 8,
                sx: {
                    borderRadius: 2,
                    minWidth: { xs: '90%', sm: 450 },
                }
            }}
            BackdropProps={{
                onClick: (e) => e.stopPropagation(),
                sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                }
            }}
        >
            <DialogTitle
                id="inactivity-warning-title"
                sx={{
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    color: 'warning.main',
                    pb: 1.5,
                    pt: 3,
                    px: 3,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                }}
            >
                <WarningAmberIcon sx={{ fontSize: '2rem' }} />
                Sessão Inativa
            </DialogTitle>
            <DialogContent
                dividers
                sx={{
                    minHeight: "120px",
                    px: 3,
                    py: 2.5,
                    borderColor: 'divider',
                }}
            >
                <DialogContentText
                    id="inactivity-warning-description"
                    sx={{
                        fontSize: '0.95rem',
                        color: 'text.secondary',
                        lineHeight: 1.6,
                        mb: 0,
                    }}
                >
                    Você será desconectado por inatividade em:
                </DialogContentText>
                <Box
                    sx={{
                        mt: 2.5,
                        mb: 1.5,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            fontSize: '3rem',
                            fontWeight: 700,
                            color: remainingSeconds <= 10 ? 'error.main' : 'warning.main',
                            fontFamily: 'monospace',
                            textAlign: 'center',
                            minWidth: '120px',
                            transition: 'color 0.3s ease',
                        }}
                    >
                        {remainingSeconds}
                    </Box>
                </Box>
                <DialogContentText
                    sx={{
                        fontSize: '0.9rem',
                        color: 'text.secondary',
                        textAlign: 'center',
                        mt: 1,
                    }}
                >
                    {remainingSeconds === 1 ? 'segundo' : 'segundos'}
                </DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    px: 3,
                    py: 2,
                    justifyContent: 'center',
                }}
            >
                <Button
                    onClick={onContinue}
                    variant='contained'
                    color='primary'
                    size='large'
                    autoFocus
                    sx={{
                        minWidth: 200,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '1rem',
                        py: 1.2,
                    }}
                >
                    Continuar Conectado
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InactivityWarningModal;
